import { render, staticRenderFns } from "./SddfTemplates.vue?vue&type=template&id=c1d35b72&scoped=true&"
import script from "./SddfTemplates.vue?vue&type=script&lang=js&"
export * from "./SddfTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d35b72",
  null
  
)

export default component.exports